import { MAPSERVERELEMENTS_TYPES } from '../../../api/MapServerElements/MapServerElements';

export default [
  {
    name: 'Layer Server Test',
    type: MAPSERVERELEMENTS_TYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_num_servic,geom`
  },
  {
    name: 'Layer Server Test 2',
    type: MAPSERVERELEMENTS_TYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_num_servic,geom`
  },
  {
    name: 'Layer Server Test 3 source',
    sourceId: 'Source Vector View',
    type: MAPSERVERELEMENTS_TYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_num_servic,geom`
  },
  {
    name: 'Layer Server Test 4 source',
    sourceId: 'Source Vector View',
    type: MAPSERVERELEMENTS_TYPES.GEOJSON,
    url: `https://geoserver.ipsilum.com/geoserver/Mapas_tematicos/wfs?request=GetFeature&service=WFS&version=1.0.0&typeName=Mapas_tematicos:mv_limpieza_distritos&outputFormat=application/json&propertyName=nombre,incr_num_servic,geom`
  }
];
